import { UserRoleDisplayName, UserRoleEnum } from '../types/user'
import type { UserRole } from '../types/user'

export const roles: Array<{
  _id: UserRole
  name: string
  description: string
}> = [
  {
    _id: UserRoleEnum.SYSTEM_ADMIN,
    name: UserRoleDisplayName.SYSTEM_ADMIN,
    description:
      'System Level: Oversees the entire platform across all churches. Responsible for creating and managing churches, assigning church administrators, and maintaining system-wide settings. Has the highest level of access and authority.',
  },
  {
    _id: UserRoleEnum.TREASURER,
    name: UserRoleDisplayName.TREASURER,
    description:
      'Church Level: Manages the financial records of the church. Can record donations, review giving history, and generate financial reports. May require approval from a church administrator before finalizing entries.',
  },
  {
    _id: UserRoleEnum.PASTOR,
    name: UserRoleDisplayName.PASTOR,
    description:
      'Church Level: Provides pastoral oversight by viewing member and giving information. Can access reports and member details to support ministry efforts but cannot modify financial data.',
  },
  {
    _id: UserRoleEnum.INVENTORY,
    name: UserRoleDisplayName.INVENTORY,
    description:
      "Church Level: Manages the church's inventory of items such as supplies, equipment, and resources. Can add, update, and track inventory items but does not have access to financial data.",
  },
  {
    _id: UserRoleEnum.DEVELOPER,
    name: UserRoleDisplayName.DEVELOPER,
    description:
      'System Level: Developer access equivalent to System Admin across all churches. Does not receive donation notifications or expense reimbursement emails.',
  },
]
